import { useEffect, useState } from "react";
import { deleteRequest, getRequest } from "../api/http";
import userServiceApi from "../api/userServiceApi";
import { toast } from "react-toastify";
import axios from "axios";

const useWorkExperienceData = (micrositeId) => {
  const [loader, setLoader] = useState(true);
  const [finalData, setFinalData] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [fileList, setFileList] = useState([]);

  const getTitlesAndData = async () => {
    try {
      setLoader(true);
      const [titleRes, oppRes, eofRes] = await Promise.all([
        getRequest(userServiceApi.getMasterDataType("WORK_TITLE")),
        getRequest(userServiceApi.getMasterDataType("WORK_OPPORTUNITY_TITLE")),
        getRequest(userServiceApi.geteof(micrositeId)),
      ]);

      if (titleRes && oppRes && eofRes) {
        const rows = titleRes.data.map((title) => {
          const virtualOpp = eofRes.data.find(
            (x) =>
              x.experienceOfWorkTitleId === title.id &&
              x.experienceOfWorkOpportunityOutput.opportunityType === "VIRTUAL"
          );

          const faceOpp = eofRes.data.find(
            (x) =>
              x.experienceOfWorkTitleId === title.id &&
              x.experienceOfWorkOpportunityOutput.opportunityType ===
                "FACE_TO_FACE"
          );

          return {
            experienceOfWorkID: title.id,
            experienceOfWorkTitle: title.value,
            virtual: {
              ...virtualOpp?.experienceOfWorkOpportunityOutput,
              id: virtualOpp?.id || null,
              experienceOfWorkOppID: oppRes.data?.[0]?.id,
              experienceOfWorkOppTitle: oppRes.data?.[0]?.value,
            },
            faceToFace: {
              ...faceOpp?.experienceOfWorkOpportunityOutput,
              id: faceOpp?.id || null,
              experienceOfWorkOppID: oppRes.data?.[1]?.id,
              experienceOfWorkOppTitle: oppRes.data?.[1]?.value,
            },
          };
        });

        setFinalData(rows);
      }
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setLoader(false);
    }
  };

  const getFiles = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getInsuranceFile(micrositeId)
      );
      if (response) {
        setExistingFiles(response.data);
      }
    } catch (error) {
      toast.error("Error fetching files");
    }
  };

  useEffect(() => {
    getTitlesAndData();
    getFiles();
  }, [micrositeId]);

  const checkFile = (file) => {
    const isPDFOrDOC =
      file.type === "application/pdf" || file.type === "application/msword";
    if (!isPDFOrDOC) toast.error("Only PDF and DOC files allowed!");
    return isPDFOrDOC;
  };

  const uploadInsuranceFile = async (formData) => {
    try {
      const response = await axios.put(
        userServiceApi.uploadInsuranceDoc(micrositeId),
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        toast.success("File uploaded successfully");
        getFiles();}
    } catch (err) {
      toast.error(err?.error || "File upload failed");
    }
  };

  const handleUploadAPI = ({ file }) => {
    const formData = new FormData();
    const blob = new Blob([file], { type: file.type });
    formData.append("file", blob, file.name);
    if (existingFiles?.documentId) {
      formData.append("documentId", existingFiles.documentId);
    }
    uploadInsuranceFile(formData);
    setFileList((prev) => ({ ...prev, [file.uid]: file }));
  };

  const handleDeleteFile = async (documentId) => {
    try {
      await deleteRequest(userServiceApi.deleteInsuranceDoc(documentId));
      toast.success("Document deleted successfully");
      getFiles();
    } catch (error) {
      toast.error("Error deleting document");
    }
  };

  const uploadProps = {
    accept: ".pdf,.doc,.docx",
    beforeUpload: checkFile,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    customRequest: handleUploadAPI,
  };

  return {
    loader,
    finalData,
    setFinalData,
    existingFiles,
    fileList,
    uploadProps,
    getFiles,
    handleDeleteFile,
  };
};

export default useWorkExperienceData;
